import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaAppleAlt } from 'react-icons/fa';
import './NutrientGapCallout.css';

/**
 * Premium: Shown when weekly plan includes healthProfile (personalized).
 * Never calorie-focused; emphasizes nutrients and variety.
 */
function NutrientGapCallout({ healthProfile }) {
  const { t } = useTranslation();
  if (!healthProfile || typeof healthProfile !== 'object') return null;

  const hasConditions = healthProfile.medicalConditionRequirements && Object.keys(healthProfile.medicalConditionRequirements).length > 0;

  return (
    <div className="nutrient-gap-callout">
      <FaAppleAlt className="nutrient-gap-callout__icon" />
      <div className="nutrient-gap-callout__content">
        <p className="nutrient-gap-callout__title">
          {t('premium.mealPlanner.nutrientCallout.title', 'Personalized to your profile')}
        </p>
        <p className="nutrient-gap-callout__text">
          {hasConditions
            ? t('premium.mealPlanner.nutrientCallout.withConditions', 'This plan respects your activity level, trimester, and any dietary considerations. Focus on variety and key nutrients—never calorie-focused.')
            : t('premium.mealPlanner.nutrientCallout.default', 'This plan is tailored to your activity level and trimester. Focus on variety and key nutrients for your stage—never calorie-focused.')}
        </p>
      </div>
    </div>
  );
}

export default NutrientGapCallout;
